module.exports = __webpack_public_path__ + "img/round-arrow-left.f572595e.svg";